module.exports = __webpack_public_path__ + "static/media/play-score-5.3a89cfc5.png";